import { TipoAtendimentoProfissional } from 'graphql/types.generated'
import { createValidator } from 'util/validation'
import { avaliacaoValidator } from 'view/atendimentos/detail/soap/avaliacao/validator'
import { desfechoValidator } from 'view/atendimentos/detail/soap/desfecho/validator'
import { objetivoValidator } from 'view/atendimentos/detail/soap/objetivo/validator'

import { planoValidator } from '../detail/soap/plano/validator'
import { subjetivoValidator } from '../detail/soap/subjetivo/validator'
import { CidadaoAtendimento } from '../types/CidadaoAtendimento'
import { SoapState } from './model'

export const atendimentoIndividualValidator = (
  cidadao: CidadaoAtendimento,
  dataAtendimento: Instant,
  tipoAtendProf: TipoAtendimentoProfissional,
  isDemandaEspontanea: boolean
) =>
  createValidator<SoapState>({
    subjetivo: subjetivoValidator,
    avaliacao: avaliacaoValidator(tipoAtendProf),
    objetivo: objetivoValidator(cidadao, dataAtendimento),
    plano: planoValidator,
    desfecho: desfechoValidator(tipoAtendProf, isDemandaEspontanea),
  })
